import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import GlobalSearch from 'app/components/complex/GlobalSearch';

import { useMapPayeeGlobalSearchResult } from './useMapPayeeGlobalSearchResults';
import { usePayeeGlobalSearch } from './usePayeeGlobalSearch';

const PayeeGlobalSearch: FC = () => {
  const [searchString, setSearchString] = useState('');

  const { t } = useTranslation('payee');

  const {
    data,
    isInitialLoading,
  } = usePayeeGlobalSearch(searchString);

  const mappedResults = useMapPayeeGlobalSearchResult(data, searchString);

  const handleClear = () => {
    setSearchString('');
  };

  return (
    <GlobalSearch
      data={mappedResults}
      isLoading={isInitialLoading}
      onClear={handleClear}
      onSubmit={setSearchString}
      placeholder={t('globalSearchPlaceholder', 'Search with Ref # or Inv #')}
    />
  );
};

export default PayeeGlobalSearch;
